<div class="page">
  <div class="logo">
    <img
      src="assets/icons/delice.png"
      alt="Logo Kissati"
      class="logo-kissati"
    />
  </div>
  <h1>Conseils Delice</h1>
  <app-loader [isLoading]="isLoading"></app-loader>

  <div class="books-grid">
    <div class="list">
      <article
        *ngFor="let article of articles"
        class="tip-card"
        [attr.data-type]="article.pathvideo ? 'video' : 'image'"
      >
        <div class="media">
          <img
            *ngIf="article.pathimage && !article.pathvideo; else videoTemplate"
            [src]="article.pathimage"
            [alt]="'Pub Delice - ' + article.id"
          />
          <ng-template #videoTemplate>
            <video
              controls
              preload="metadata"
              [poster]="
                article.imagemedia ||
                'https://via.placeholder.com/300x200.png?text=Video'
              "
            >
              <source [src]="article.pathvideo" type="video/mp4" />
              Votre navigateur ne supporte pas la vidéo.
            </video>
          </ng-template>
        </div>
        <div class="content">
          <h2>{{ article.label }}</h2>
          <h3 class="creation-date">
            <span class="date-icon">📅</span>
            {{ article.creationDate | date: "dd-MM-yyyy" }}
          </h3>
          <p>{{ article.description }}</p>
        </div>
      </article>

      <div *ngIf="articles.length === 0 && !isLoading" class="empty">
        Aucun conseil à afficher.
      </div>
    </div>
  </div>

  <div class="pagination-simple">
    <button
      class="btn-prev"
      (click)="previousPage()"
      [disabled]="currentPage === 1"
    >
      {{ "kissati.previous" | translate }}
    </button>
    <button
      *ngFor="let page of pageNumbers"
      (click)="goToPage(page)"
      [class.font-bold]="currentPage === page"
      class="px-3 py-2 hover:bg-[#65cac3] rounded transition-colors duration-200"
      style="border: 1px solid #65cac3"
    >
      {{ page }}
    </button>
    <button
      class="btn-next"
      (click)="nextPage()"
      [disabled]="currentPage === totalPages"
    >
      {{ "kissati.next" | translate }}
    </button>
  </div>
</div>
